<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
	export default {
	  name: 'app',
	  components: {}
	}
</script>

<style>
	body {
	  margin: 0;
	}
	
	#app {
	  font-family: Avenir, Helvetica, Arial, sans-serif;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
	  text-align: center;
	  color: #2c3e50;
	}

	.BMap_cpyCtrl {
	  display: none;
	}
	.anchorBL {
	  display: none
	}

	.v-modal{
		z-index: 0 !important;
	}

</style>
